import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signIn, currentIdToken, SignInResult } from '../auth/cognito';

export function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [challenge, setChallenge] = useState<Extract<SignInResult, { status: 'newPasswordRequired' }> | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    void currentIdToken().then((t) => {
      if (t) navigate('/admin/games', { replace: true });
    });
  }, [navigate]);

  const handle = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const res = challenge
        ? await challenge.complete(newPassword)
        : await signIn(email.trim(), password);
      if (res.status === 'newPasswordRequired') {
        setChallenge(res);
      } else {
        navigate('/admin/games', { replace: true });
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sign-in failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="card centered">
      <h1>Host sign in</h1>
      {error && <div className="banner error">{error}</div>}
      <form onSubmit={handle} className="stack">
        {!challenge ? (
          <>
            <label>
              Email
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" />
            </label>
            <label>
              Password
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
            </label>
          </>
        ) : (
          <>
            <p className="muted">First sign-in — choose a new password.</p>
            <label>
              New password
              <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} autoComplete="new-password" />
            </label>
          </>
        )}
        <button type="submit" className="primary" disabled={busy}>
          {busy ? 'Signing in…' : challenge ? 'Set password & continue' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
